module.exports = __webpack_public_path__ + "img/151.6979f0b6.png";